<template>
    <svg :class="svgClass" xmlns="http://www.w3.org/2000/svg"
         :height="height"
         :width="width"
         :viewBox="viewBox ? viewBox : `0 0 ${icon.width} ${icon.height}`"
         fill="currentColor">
        <path :d="icon.path"></path>
    </svg>
</template>

<script>
    export default {
        props: {
            icon: {
                type: Object,
                required: true,
            },
            svgClass: {
                type: String,
            },
            height: {
                type: String,
                default: "1em",
            },
            width: {
                type: String,
                default: "1em",
            },
            viewBox: {
                type: String,
            },
        }
    }
</script>
